import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerCreatedEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}